import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ShareImageToSocialMedia from "core/ShareImageToSocialMedia";

import Facebook from "core/icons/Facebook";
import Twitter from "core/icons/Twitter";

import Flexbox from "core/Flexbox";
import colors from "core/colors";
import { SocialsWrapper, TextWrapper, Wrapper } from "./styles";

import { PHOTO_DETAIL } from "data/links";

const UnwrappedMessageBanner = ({
    className,
    showSocialLinks,
    accentColor,
    icon,
    iconTitle,
    photo,
    children
}) => {
    const Icon = icon;

    return (
        <Wrapper className={className} accentColor={accentColor}>
            <Flexbox alignItems="center" justifyContent="space-between">
                <Flexbox alignItems="center">
                    {/* 'size' and 'fillColor' props are used
                    to style "styled-svg" components only */}
                    <Icon
                        title={iconTitle}
                        size={{ width: 21, height: 21 }}
                        fillColor={accentColor}
                    />
                    <TextWrapper>{children}</TextWrapper>
                </Flexbox>
                {showSocialLinks && (
                    <SocialsWrapper
                        flexWrap="nowrap"
                        alignItems="center"
                        justifyContent="flex-end"
                    >
                        <ShareImageToSocialMedia
                            platform="Facebook"
                            creatorName={photo.creator.name}
                            imageType="photo"
                            permalinkPath={PHOTO_DETAIL.replace(
                                ":photoSlugWithId",
                                photo.slugWithId
                            )}
                        >
                            <Facebook
                                title="Facebook logo"
                                fillColor={colors.mist}
                                size={{ width: 24, height: 24 }}
                            />
                        </ShareImageToSocialMedia>
                        <ShareImageToSocialMedia
                            platform="Twitter"
                            creatorName={photo.creator.name}
                            imageType="photo"
                            permalinkPath={PHOTO_DETAIL.replace(
                                ":photoSlugWithId",
                                photo.slugWithId
                            )}
                        >
                            <Twitter
                                title="Twitter logo"
                                fillColor={colors.mist}
                                size={{ width: 23, height: 23 }}
                            />
                        </ShareImageToSocialMedia>
                    </SocialsWrapper>
                )}
            </Flexbox>
        </Wrapper>
    );
};

UnwrappedMessageBanner.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    showSocialLinks: PropTypes.bool,
    accentColor: PropTypes.string,
    photo: PropTypes.object,
    iconTitle: PropTypes.string,
    // pass React component, like an SVG styled-component
    icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
};

const MessageBanner = styled(UnwrappedMessageBanner)``;

export default MessageBanner;
